module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/236-republic-of-macedonia-a3520a35ce6a036e4e297547fb3142ee.svg";